import React from 'react';

import { AccordionSummary } from '@mui/material';
import { Typography } from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const QualificationAccordionSummary = (props) => {

    const { title, children, fontSize, fontWeight, ...otherProps } = props;

    return (

        <AccordionSummary expandIcon={<ExpandMoreIcon {...otherProps} />} >
            <Typography style={{ fontSize: fontSize, fontWeight: fontWeight }}>{title}</Typography>
            {children}
        </AccordionSummary>
    )
};


QualificationAccordionSummary.defaultProps = {
    fontSize: "x-large",
    fontWeight: "bold"
}

export default QualificationAccordionSummary;